import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { Building2, LogOut } from 'lucide-react';

const TenantLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const { t, language, setLanguage } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      {/* Header */}
      <header className="bg-white border-b border-black px-6 py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Building2 className="w-7 h-7" />
            <span className="font-heading text-xl font-bold tracking-tight">RentFlow</span>
          </div>

          <div className="flex items-center gap-4">
            {/* Language Toggle */}
            <div className="flex border border-gray-300">
              <button
                onClick={() => setLanguage('en')}
                className={`px-3 py-1 text-sm font-medium transition-colors ${
                  language === 'en' ? 'bg-black text-white' : 'bg-white text-black hover:bg-gray-100'
                }`}
              >
                EN
              </button>
              <button
                onClick={() => setLanguage('tr')}
                className={`px-3 py-1 text-sm font-medium transition-colors ${
                  language === 'tr' ? 'bg-black text-white' : 'bg-white text-black hover:bg-gray-100'
                }`}
              >
                TR
              </button>
            </div>

            {/* User */}
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-black text-white flex items-center justify-center text-sm font-bold">
                {user?.name?.charAt(0).toUpperCase()}
              </div>
              <span className="text-sm font-medium hidden sm:block">{user?.name}</span>
            </div>

            {/* Logout */}
            <button
              onClick={handleLogout}
              className="p-2 text-red-600 hover:bg-red-50 transition-colors"
              data-testid="tenant-logout-btn"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto p-6">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-6 text-center text-sm text-gray-500">
        © 2026 RentFlow. All rights reserved.
      </footer>
    </div>
  );
};

export default TenantLayout;
